import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import VisitorGate from "@/pages/VisitorGate";
import RawFootage from "@/pages/RawFootage";
import ShortClips from "@/pages/ShortClips";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import SharedAccess from "@/pages/SharedAccess";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth Context
export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

// Visitor context - check if visitor has signed in
const VisitorContext = createContext(null);
export const useVisitor = () => useContext(VisitorContext);

function VisitorGuard({ children }) {
  const { visitor } = useVisitor();
  if (!visitor) return <Navigate to="/" replace />;
  return children;
}

function AdminGuard({ children }) {
  const { admin } = useAuth();
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  const [visitor, setVisitor] = useState(() => {
    const saved = localStorage.getItem("hify_visitor");
    return saved ? JSON.parse(saved) : null;
  });

  const [admin, setAdmin] = useState(() => {
    const saved = localStorage.getItem("hify_admin");
    return saved ? JSON.parse(saved) : null;
  });

  const loginVisitor = (data) => {
    localStorage.setItem("hify_visitor", JSON.stringify(data));
    setVisitor(data);
  };

  const loginAdmin = (data) => {
    localStorage.setItem("hify_admin", JSON.stringify(data));
    setAdmin(data);
  };

  const logoutAdmin = () => {
    localStorage.removeItem("hify_admin");
    setAdmin(null);
    axios.post(`${API}/auth/logout`, {}).catch(() => {});
  };

  return (
    <AuthContext.Provider value={{ admin, loginAdmin, logoutAdmin, API }}>
      <VisitorContext.Provider value={{ visitor, loginVisitor, API }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<VisitorGate />} />
            <Route path="/access/:token" element={<SharedAccess />} />
            <Route path="/raw-footage" element={<VisitorGuard><RawFootage /></VisitorGuard>} />
            <Route path="/clips" element={<VisitorGuard><ShortClips /></VisitorGuard>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGuard><AdminPanel /></AdminGuard>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </VisitorContext.Provider>
    </AuthContext.Provider>
  );
}

export default App;
